import { render, staticRenderFns } from "./TagFormButtons.vue?vue&type=template&id=58bb5ded&scoped=true&"
import script from "./TagFormButtons.vue?vue&type=script&lang=js&"
export * from "./TagFormButtons.vue?vue&type=script&lang=js&"
import style0 from "./TagFormButtons.vue?vue&type=style&index=0&id=58bb5ded&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb5ded",
  null
  
)

export default component.exports